import React from 'react'
import { cn } from '../../../lib/utils'

export type TimeRangePreset = 'today' | '7d' | '30d' | '90d' | 'custom'

type Props = {
 active: TimeRangePreset
 onChange: (preset: TimeRangePreset) => void
 labels: Record<TimeRangePreset, string>
 className?: string
}

const PRESETS: TimeRangePreset[] = ['today', '7d', '30d', '90d', 'custom']

const TimeRangeChips: React.FC<Props> = ({ active, onChange, labels, className }) => (
 <div className={cn('inline-flex flex-wrap gap-1 rounded-xl border border-border-subtle bg-muted/30 p-1', className)}>
  {PRESETS.map((preset) => (
   <button
    key={preset}
    type="button"
    onClick={() => onChange(preset)}
    className={cn(
     'rounded-lg px-3 py-1.5 text-xs font-medium transition-all',
     active === preset
      ? 'bg-background text-foreground shadow-sm ring-1 ring-border-subtle/50'
      : 'text-muted-foreground hover:text-foreground',
    )}
   >
    {labels[preset]}
   </button>
  ))}
 </div>
)

export default TimeRangeChips
